import Archivos from "./reports/Archivos";
import Usuarios from "./reports/Usuarios";

export default function getReportPDF(report: number, data: any, extra?: object){
    switch(report){
        case 1: return Archivos(data.data);
        case 2: return Usuarios(data.data);
        default: throw new Error("El reporte seleccionado no existe", {cause: 404});
    }
}